
export default {
    name: 'cat-consignes',
    components: {},
    props: ["cat_consignes", "hn", "protocole_id", "can_show_empty"],
    data() {
        return {
            is_loading: true,
            is_empty: false
        }
    },

    watch: {
        cat_consignes() {
            this.getConsignes()
        }
    },

    computed: {

    },

    mounted() {
        this.getConsignes()
    },

    methods: {
        getConsignes() {
            this.is_loading = true
            if (this.cat_consignes.length > 0) {
                this.is_empty = false
            } else {
                this.is_empty = true
            }

            setTimeout(() => {
                this.is_loading = false
            }, 500);
        }
    }
}